module.exports = __webpack_public_path__ + "static/media/jordanian-embassy.5c74f52c.png";